import { useState } from "react"
import { Button, Collapse, ListItem, Link as LinkH, Box } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import { Link as RouterLink } from "react-router-dom"

const styles = {
  item: {
    display: "block",
    paddingTop: 0,
    paddingBottom: 0,
  },
  itemLeaf: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: "#546e7a",
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
  },
  buttonLeaf: {
    color: "#546e7a",
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
    "&.depth-0": {
      "& $title": {
        fontWeight: 300,
      },
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    marginRight: 1,
  },
  title: {
    marginRight: "auto",
  },
  active: {
    color: "#20aaf5",
    "& $title": {
      fontWeight: 300,
    },
    "& $icon": {
      color: "#20aaf5",
    },
  },
  link: {
    textDecoration: "inherit",
    "&:hover": {
      textDecoration: "inherit",
    },
  },
  badge: {
    backgroundColor: "#EF4444",
    color: "#FFFFFF",
    fontSize: "0.625rem",
    fontWeight: "bold",
    padding: "2px 6px",
    borderRadius: "12px",
    lineHeight: 1,
    marginLeft: "8px",
  },
}

function NavItem({
  title,
  href,
  redirect,
  depth,
  children,
  icon: Icon,
  className,
  open: openProp,
  info: Info,
  hide,
  badge,
  ...rest
}: any) {
  const [open, setOpen] = useState(openProp)

  const handleToggle = () => {
    setOpen((prevOpen: any) => !prevOpen)
  }

  let paddingLeft = 8
  if (depth > 0) {
    paddingLeft = 32 + 8 * depth
  }

  const style = { paddingLeft }

  if (children) {
    return (
      <>
        <ListItem sx={styles.item} disableGutters key={title} {...rest}>
          <Button sx={styles.button} onClick={handleToggle} style={style}>
            {Icon && <Icon sx={styles.icon} size="20" />}
            <span style={styles.title}>{title}</span>
            {badge && <Box sx={styles.badge}>{badge}</Box>}
            {open ? (
              <ExpandLessIcon fontSize="small" color="inherit" />
            ) : (
              <ExpandMoreIcon fontSize="small" color="inherit" />
            )}
          </Button>
          <Collapse in={open}>{children}</Collapse>
        </ListItem>
      </>
    )
  }

  return (
    <>
      {!hide && (
        <ListItem sx={styles.itemLeaf} disableGutters key={title} {...rest}>
          {redirect ? (
            <LinkH href={href} sx={styles.link} target="_blank">
              <Button sx={styles.buttonLeaf} style={style}>
                {Icon && <Icon sx={styles.icon} size="20" />}
                <span style={styles.title}>{title}</span>
                {badge && <Box sx={styles.badge}>{badge}</Box>}
                {Info && <Info />}
              </Button>
            </LinkH>
          ) : (
            <RouterLink to={href} style={styles.link}>
              <Button sx={styles.buttonLeaf} style={style}>
                {Icon && <Icon sx={styles.icon} size="20" />}
                <span style={styles.title}>{title}</span>
                {badge && <Box sx={styles.badge}>{badge}</Box>}
                {Info && <Info />}
              </Button>
            </RouterLink>
          )}
        </ListItem>
      )}
    </>
  )
}

export default NavItem
